export default "__VITE_ASSET__B7K0G3jn__"